let GameGuideMask = require("clover/gameGuide/GameGuideMask")
let GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
ActivityGuideAni = xClass("ActivityGuideAni")

var resList = [
    //animalBubbleUp 的资源，暂定
    "cocos/game_guide_anim1_guideanim_in.csb",
    "cocos/clover_animation.plist",
    "cocos/game_guide_anim3_guideanim_front_speak1.csb",
    "cocos/game_guide_anim3_guideanim_front_speak2.csb",
    "cocos/clover_animation_fish.plist",
    "cocos/game_guide_anim_res.plist"
];

let AnimalY = -display.height/2 + 150
let AnimalX = -470
ActivityGuideAni.asyncCreate = function (action, logic,skipCb,zorder) {
    function onSuccess() {
        ActivityGuideAni.create(action, logic,skipCb,zorder);
        // panel.popup(true, false, null, true);
    }
    preloadWithLoading(resList, onSuccess);
}

ActivityGuideAni.prototype.ctor  = function (actionList, logic,skipCb,zorder) {
    let self = this

    self.guildIndex = 1
    
    if (!actionList[self.guildIndex]) return

    self.logic = logic
    logic.runningGuide = self //传入管理类
    self.actionList = actionList
    self.skipCb = skipCb //跳过cb
    self.init(zorder)

    
    


}
ActivityGuideAni.prototype.init = function (zorder) {
    let self = this;

    let action = self.actionList[self.guildIndex]

    self.node = cc.Node.create()
    action.root.addChild(self.node)

    self.node.setPosition(0, -action.root.bannerAdOffsetY)
    self.node.setScale( 1 / action.root.getScale())
    if (zorder)self.node.setLocalZOrder(zorder)
    // self.init();

    action.maskAction && self.buildMask(action.maskAction)
    action.skipText && self.buildSkip()
    action.guideAction && self.buildAnimal (action.guideAction)
    action.handAction && self.handAnim (action.handAction)

    action.runningCb && action.runningCb() //正在运行
    self.action = action
}

ActivityGuideAni.prototype.buildAnimal = function(action) {

    let self = this
    let jumpupAnim = GameGuideAnims[action.type](action)
    self.jumpupAnim = jumpupAnim
    // jumpupAnim.setPosition(0, 0)
    self.node.addChild(jumpupAnim)
}
ActivityGuideAni.prototype.buildMask = function (action) {
    let self = this


    let mask = UIButton.create(GameGuideMask.create(action))

    mask.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
        mask.on(UIButtonEvent.Click, function () {
            // console.log("click mask")
            // mask.removeFromParent(true)
            // self.skipTxt && self.skipTxt.removeFromParent(true)
            // if (callback) {
            //     // callback()
            // }
        })
    }), cc.DelayTime.create(4), cc.CallFunc.create(function(){
        // mask.removeFromParent(true)
        // self.skipTxt && self.skipTxt.removeFromParent(true)
        // if (callback) {
        //     callback()
        // }
    })))
    // }
    let size = mask.getContentSize()
    mask.setContentSize(cc.size(size.width + 240, size.height))
    mask.setPosition( -display.width/2, -display.height/2)
    self.node.addChild(mask)

}
ActivityGuideAni.prototype.handAnim = function(action) {

    let self = this

    let animal = GameGuideAnims.handClick(action)
    // animal.setPosition(-display.width/ 2, -display.height / 2)
    self.node && self.node.addChild(animal)
}

ActivityGuideAni.prototype.skip = function () {
    var self = this
    self.action.closeCb && self.action.closeCb() //引导结束回调
    self.guildIndex++;
    if (self.actionList[self.guildIndex]) {
        self.node && self.node.removeFromParent()
        self.init()
    }else {
        self.onClose()
    }

}
ActivityGuideAni.prototype.buildSkip = function () {
    var self = this
    var text = cc.Label.createWithSystemFont(getText("tutorial.skip"), null, 36)
    // text.setColor(cc.c4b(102, 204, 255, 255))
    text.setColor(cc.c4b(240, 255, 255, 255))
    text.setAnchorPoint(cc.p(0.5, 0.5))
    text.setPosition(cc.p(display.width / 2 - 100, AnimalY - 100))
    quickBuildUIButton(text, ()=>{

    
        self.onClose()

    })
    self.node.addChild(text)
}

ActivityGuideAni.prototype.onClose = function() {
    let self = this
    self.node && self.node.removeFromParent()

    self.skipCb && self.skipCb()
    self.logic.runningGuide = null
    unloadResList(resList);
}

module.exports = ActivityGuideAni